var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    { staticClass: "width-1150-important" },
    [
      _c(
        "el-row",
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { staticStyle: { width: "100%" } },
                [
                  _c(
                    "el-col",
                    { staticClass: "fundSelector_tab", attrs: { span: 20 } },
                    [_vm._v("\n            风险指标\n          ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { staticClass: "right_text_align", attrs: { span: 4 } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "fundSelector_Company",
                          attrs: {
                            placeholder: "请选择时间周期",
                            disabled: _vm.invalidPeriod,
                          },
                          model: {
                            value: _vm.perforamncePeriod,
                            callback: function ($$v) {
                              _vm.perforamncePeriod = $$v
                            },
                            expression: "perforamncePeriod",
                          },
                        },
                        _vm._l(_vm.periodList, function (item) {
                          return _c("el-option", {
                            key: item.period,
                            attrs: { label: item.value, value: item.period },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", {
            staticClass: "table-line",
            staticStyle: { "margin-top": "15px", "margin-bottom": "5px" },
          }),
          _vm._v(" "),
          _c(
            "el-row",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.performanceLoading,
                  expression: "performanceLoading",
                },
              ],
            },
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%", "margin-top": "5px" },
                  attrs: {
                    data: _vm.performanceTableData,
                    "cell-class-name": _vm.cellStyle,
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "dpNameLocal", label: "名称", width: "350" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "fund",
                      label: _vm.categoryDisplayName,
                      width: "300",
                      align: "right",
                      "header-align": "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm._f("fixValue")(scope.row.fund)) +
                                "\n        "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "category",
                      label: _vm.categoryAverageName,
                      width: "250",
                      align: "right",
                      "header-align": "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm._f("fixValue")(scope.row.category)) +
                                "\n        "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "benchmark",
                      label: _vm.benchmarkName,
                      "min-width": "250",
                      align: "right",
                      "header-align": "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm._f("fixValue")(scope.row.benchmark)
                                ) +
                                "\n        "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                {
                  staticClass: "risk_date left_text_align",
                  staticStyle: { color: "#909399", "margin-top": "10px" },
                },
                [
                  _vm._v(
                    "起止日期：" + _vm._s(_vm.performanceStartEnd) + "\n       "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticStyle: { "margin-top": "35px" } },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { staticClass: "fundSelector_tab", attrs: { span: 24 } },
                [_vm._v("\n            历史回报\n          ")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", {
            staticClass: "table-line",
            staticStyle: { "margin-top": "15px", "margin-bottom": "5px" },
          }),
          _vm._v(" "),
          _c(
            "el-row",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.returnLoading,
                  expression: "returnLoading",
                },
              ],
            },
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%", "margin-top": "5px" },
                  attrs: {
                    data: _vm.returnTableData,
                    "cell-class-name": _vm.cellStyle,
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "periodLocal", label: "名称", width: "350" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "fund",
                      label: _vm.categoryDisplayName,
                      width: "300",
                      "header-align": "center",
                      align: "right",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm._f("fixValue")(scope.row.fund)) +
                                "\n        "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "category",
                      label: _vm.categoryAverageName,
                      width: "250",
                      "header-align": "center",
                      align: "right",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm._f("fixValue")(scope.row.category)) +
                                "\n        "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "benchmark",
                      label: _vm.benchmarkName,
                      "min-width": "250",
                      "header-align": "center",
                      align: "right",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm._f("fixValue")(scope.row.benchmark)
                                ) +
                                "\n        "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                {
                  staticClass: "risk_date left_text_align",
                  staticStyle: { color: "#909399", "margin-top": "10px" },
                  attrs: { span: 24 },
                },
                [_vm._v("截止日期：" + _vm._s(_vm.periodEndDate) + "\n       ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticStyle: { "margin-top": "35px", "margin-bottom": "25px" } },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { staticStyle: { width: "100%" } },
                [
                  _c(
                    "el-col",
                    { staticClass: "fundSelector_tab", attrs: { span: 20 } },
                    [_vm._v("\n            风险收益分布\n          ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { staticClass: "right_text_align", attrs: { span: 4 } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "fundSelector_Company",
                          attrs: {
                            placeholder: "请选择时间周期",
                            disabled: _vm.invalidPeriod,
                          },
                          model: {
                            value: _vm.riskPeriod,
                            callback: function ($$v) {
                              _vm.riskPeriod = $$v
                            },
                            expression: "riskPeriod",
                          },
                        },
                        _vm._l(_vm.periodList, function (item) {
                          return _c("el-option", {
                            key: item.period,
                            attrs: { label: item.value, value: item.period },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", {
            staticClass: "table-line",
            staticStyle: { "margin-top": "15px" },
          }),
          _vm._v(" "),
          _c(
            "el-row",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.riskLoading,
                  expression: "riskLoading",
                },
              ],
            },
            [
              _c(
                "el-col",
                { staticClass: "left_text_align", attrs: { span: 5 } },
                [
                  _c("canvas", { attrs: { id: "canvasKey" } }),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    {
                      staticClass: "risk_date left_text_align",
                      staticStyle: { color: "#909399" },
                    },
                    [
                      _vm._v(
                        "起止日期：" + _vm._s(_vm.riskStartEnd) + "\n       "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 19 } },
                [
                  _c(
                    "el-row",
                    [
                      _c("el-col", { staticClass: "right_text_align" }, [
                        _c("canvas", {
                          staticClass: "right_text_align",
                          staticStyle: { display: "block" },
                          attrs: {
                            id: "canvasAR",
                            width: "800",
                            height: "110",
                          },
                        }),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "table-line" }),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    [
                      _c("el-col", { staticClass: "right_text_align" }, [
                        _c("canvas", {
                          staticClass: "right_text_align",
                          staticStyle: { display: "block" },
                          attrs: {
                            id: "canvasMD",
                            width: "800",
                            height: "110",
                          },
                        }),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "table-line" }),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    [
                      _c("el-col", { staticClass: "right_text_align" }, [
                        _c("canvas", {
                          staticClass: "right_text_align",
                          staticStyle: { display: "block" },
                          attrs: {
                            id: "canvasSR",
                            width: "800",
                            height: "110",
                          },
                        }),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "table-line" }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }